import { ApolloError } from '@apollo/client';

export const isLoading = (responses: Array<{ loading?: boolean }>): boolean =>
  responses.some(_response => _response.loading);

export const getError = (
  response: Array<{ error?: ApolloError }>,
): ApolloError | undefined =>
  response.find(_response => _response.error)?.error;
